/* Toubkal bundle-keuze: prijzen bijwerken + 1/2/4 paar in de cart leggen (korting = bestaande 1+1 FREE). */
(function () {
  var root = document.querySelector('[data-tk-bundle]');
  if (!root) return;
  var data;
  try { data = JSON.parse(root.querySelector('[data-tk-bundle-product]').textContent); } catch (e) { return; }
  var section = root.getAttribute('data-section');
  var cur = root.getAttribute('data-currency') || 'GBP';
  var fmt = function (cents) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };
  function getBtn() { return document.getElementById('ProductSubmitButton-' + section); }
  function mainVariantId() {
    var b = getBtn(), f = b && b.form;
    var inp = f && f.querySelector('input[name="id"]');
    return inp ? Number(inp.value) : null;
  }
  function variantById(id) { return data.variants.filter(function (v) { return v.id === id; })[0]; }
  function variantByOptions(opts) {
    return data.variants.filter(function (v) {
      return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; });
    })[0];
  }
  function selectedTier() {
    var r = root.querySelector('input[type=radio]:checked');
    return r ? Number(r.value) : 1;
  }

  function updatePrices() {
    var v = variantById(mainVariantId()) || data.variants[0];
    if (!v) return;
    var cmp = v.compare_at_price > v.price ? v.compare_at_price : v.price;
    root.querySelectorAll('[data-tk-tier]').forEach(function (tier) {
      var n = Number(tier.getAttribute('data-tk-tier'));
      var paid = Math.ceil(n / 2);
      var pay = v.price * paid, was = cmp * n;
      var p = tier.querySelector('[data-tk-pay]'); if (p) p.textContent = fmt(pay);
      var w = tier.querySelector('[data-tk-was]'); if (w) { w.textContent = fmt(was); w.hidden = !(was > pay); }
      var e = tier.querySelector('[data-tk-each]'); if (e) e.textContent = fmt(Math.round(pay / n)) + ' each';
    });
    updateButton();
  }

  function updateButton() {
    var mainBtn = getBtn();
    if (!mainBtn) return;
    var span = mainBtn.querySelector('span');
    if (!span || mainBtn.disabled) return;
    var n = selectedTier();
    if (!span.getAttribute('data-tk-orig')) span.setAttribute('data-tk-orig', span.textContent.trim());
    span.textContent = n === 1 ? span.getAttribute('data-tk-orig') : 'Add ' + n + ' pairs to cart';
  }

  function setActive() {
    root.querySelectorAll('[data-tk-tier]').forEach(function (t) {
      t.classList.toggle('is-active', t.querySelector('input[type=radio]').checked);
    });
    updateButton();
  }

  /* extra paren standaard gelijk aan paar 1 als de klant paar 1 wijzigt */
  var lastMain = null;
  function syncPairsToMain() {
    var id = mainVariantId();
    if (id === lastMain) return;
    lastMain = id;
    var v = variantById(id);
    if (v) {
      root.querySelectorAll('[data-tk-pair]').forEach(function (pair) {
        if (pair.getAttribute('data-touched')) return;
        pair.querySelectorAll('[data-tk-opt]').forEach(function (sel) {
          var val = v.options[Number(sel.getAttribute('data-tk-opt'))];
          if (val !== undefined) sel.value = val;
        });
      });
    }
    updatePrices();
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('input[type=radio]')) setActive();
    if (e.target.matches('[data-tk-opt]')) { e.target.closest('[data-tk-pair]').setAttribute('data-touched', '1'); hideError(); }
  });

  var err = root.querySelector('[data-tk-bundle-error]');
  function showError(msg) { if (err) { err.textContent = msg; err.hidden = false; } }
  function hideError() { if (err) err.hidden = true; }

  /* Add to cart onderscheppen bij 2 of 4 paar */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var mainBtn = e.target.closest('#ProductSubmitButton-' + section) || e.target.closest('.sticky-atc-section .product-form__submit, .sticky-atc-section button[type="submit"]');
    if (!mainBtn) return;
    var n = selectedTier();
    if (n <= 1) return; /* 1 paar: normale knop */
    e.preventDefault(); e.stopImmediatePropagation();
    hideError();
    var items = [{ id: mainVariantId(), quantity: 1 }];
    var tier = root.querySelector('[data-tk-tier="' + n + '"]');
    var bad = false;
    tier.querySelectorAll('[data-tk-pair]').forEach(function (pair, idx) {
      var opts = [];
      pair.querySelectorAll('[data-tk-opt]').forEach(function (sel) { opts[Number(sel.getAttribute('data-tk-opt'))] = sel.value; });
      var v = opts.length ? variantByOptions(opts) : data.variants[0];
      if (!v || !v.available) { bad = 'Pair ' + (idx + 2) + ': this colour/size is sold out. Please choose another.'; return; }
      items.push({ id: v.id, quantity: 1 });
    });
    if (bad) { showError(bad); return; }
    /* zelfde variant samenvoegen */
    var merged = {};
    items.forEach(function (it) { merged[it.id] = (merged[it.id] || 0) + it.quantity; });
    items = Object.keys(merged).map(function (id) { return { id: Number(id), quantity: merged[id] }; });

    mainBtn.classList.add('loading'); mainBtn.setAttribute('aria-disabled', 'true');
    var sp = mainBtn.querySelector('.loading__spinner'); if (sp) sp.classList.remove('hidden');
    var drawer = document.querySelector('cart-drawer');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status && state.description) { showError(state.description); return; }
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        }
        else window.location.href = '/cart';
      })
      .catch(function () { showError('Something went wrong. Please try again.'); })
      .then(function () {
        mainBtn.classList.remove('loading'); mainBtn.removeAttribute('aria-disabled');
        if (sp) sp.classList.add('hidden');
      });
  }, true);

  setActive();
  syncPairsToMain();
  setInterval(function () { syncPairsToMain(); updateButton(); }, 400);
})();
